



import { Component, Vue, Prop, Watch} from 'vue-property-decorator';
import * as Components from '@/tenant/components';
import * as Common from '@/tenant/common';

@Component
export default class AtcSegment extends Vue {
  @Prop({ default: '' }) public title: string;
  @Prop({ default: null }) public value?: any | Common.IMasterItem;
  @Prop({ default: false }) public required: boolean;
  @Prop({ default: null }) public editor: Components.IEditor;
  @Prop({ default: true }) public enabled: boolean;
  @Prop() public tooltip: string;
  @Prop({default:true}) public isDirectEditEnabled:boolean;
  @Prop({ default: false }) public setInitialValue: boolean; //AtcSegmentのisEdit制御相当の実装ではダイアログ表示で反映しなかったので必要な実装箇所でフラグをセットする(検索画面を対象外にしたい)=>入出金伝票などでも使用できます  
  public isEdit: boolean = true;
  public validator: Components.ControlValidator = null;

  public created() {
    if (this.editor != null) this.editor.addControl(this);
  }

  public mounted(){
    //請求処理の初期値をセットする
    this.$nextTick(()=>{
      if(this.value==null && this.setInitialValue==true){
        this.$api.execute(new Common.BankAccountMasterQuery()).then(result => {
          if((result as Common.LoadResult).records==1){            
            this.$emit('update:value', (result as Common.LoadResult).result[0]);
          }
        });
      }    
    });
  }
  public destroyed(){
    if (this.editor != null) this.editor.removeControl(this);    
  }  

  public get internalValue(): string {
    return this.value;
  }

  public set internalValue(value: string) {
    this.$emit('update:value', value);
    this.$emit('changed');
  }
}
  
